import './Address.sass';

import React, { FC, useCallback } from 'react';
import { AddressProps } from './Address.interface';
import { classNames as cn } from '$utils';
import copyToClipboard from 'copy-text-to-clipboard';
import { toastActions } from '$store/toast';
import { useDispatch } from 'react-redux';
import { useTranslator } from '$hooks';

export const Address: FC<AddressProps> = ({ address, canCopy, className }) => {
  const dispatch = useDispatch();
  const t = useTranslator();

  const handleClick = useCallback(() => {
    if (canCopy && address) {
      copyToClipboard(address);
      dispatch(toastActions.setToastSuccess(t('copied')));
    }
  }, [canCopy]);

  return (
    <span onClick={handleClick} className={cn('Address', className)}>
      {address ? `${address.substr(0, 7)}...${address.substr(-7)}` : ''}
    </span>
  );
};
